import { memo } from 'react';
import { FlexBox } from '@dfl/mui-react-common';
import { useTranslation } from 'react-i18next';

type TabLabelProps = {
  label: string;
  Icon: any;
  disabled?: boolean;
  ns: string;
};

const TabLabel = ({ label, Icon, disabled, ns }: TabLabelProps) => {
  const { t } = useTranslation(ns);

  return (
    <FlexBox
      gap={1}
      alignItems={'center'}
      color={!disabled ? 'primary.main ' : undefined}
    >
      <Icon /> {t(label)}
    </FlexBox>
  );
};

export default memo(TabLabel);
